var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarAccountSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6414_3048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66992 17.8809H14.7656C15.8105 17.8809 16.4355 17.3926 16.4355 16.582C16.4355 14.0625 13.2812 10.5859 8.21289 10.5859C3.1543 10.5859 0 14.0625 0 16.582C0 17.3926 0.625 17.8809 1.66992 17.8809ZM8.22266 8.83789C10.3125 8.83789 12.1289 6.96289 12.1289 4.52148C12.1289 2.10938 10.3125 0.322266 8.22266 0.322266C6.13281 0.322266 4.31641 2.14844 4.31641 4.54102C4.31641 6.96289 6.12305 8.83789 8.22266 8.83789Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6414_3048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4355,
    height: 17.8809,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarAccountSelected);
export default __webpack_public_path__ + "static/media/tabbar-account-selected.9bdcb5b41bfd4598e5c42d73a779a8c5.svg";
export { ForwardRef as ReactComponent };